module.exports = __webpack_public_path__ + "img/圆点大.e5447ba3.png";